// Menu toggle js
jQuery(document).ready(function ($) {
    $('.menu-toggle').on('click', function () {
        $('.primary-menu-container').toggleClass('view');
        $('.main-navigation').toggleClass('toggled');
    });
});


// Change Header bg-color on scroll
jQuery(document).ready(function ($) {
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 50) {
            $('#dynamic').addClass('header-scrolled');
        } else {
            $('#dynamic').removeClass('header-scrolled');
        }
    });
});

// lock background scroll js
document.addEventListener("DOMContentLoaded", function () {
    const menu = document.querySelector(".primary-menu-container");
    const toggleBtn = document.querySelector(".menu-toggle");

    if (toggleBtn && menu) {
        // Open menu
        toggleBtn.addEventListener("click", function () {
            menu.classList.toggle("open");
            document.body.classList.toggle("menu-open");
        });
    }
});


// WorkWeDo slider - only for <768
document.addEventListener("DOMContentLoaded", function () {
    const WorkWeDoSlider = document.querySelector(".WorkWeDo");

    if (WorkWeDoSlider && window.innerWidth < 768) {
        new Swiper(WorkWeDoSlider, {
            slidesPerView: "auto",
            loop: true,
            freeMode: true,
            freeModeMomentum: false,
            speed: 5000,
            autoplay: {
                delay: 0, // continuous autoplay
                disableOnInteraction: false, // keeps moving after user interaction
            },
        });
    }
});



// SlideInRight 
document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".ourpropmise_wrapper");

    if (!wrapper) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    wrapper.classList.add("active");
                } else {
                    wrapper.classList.remove("active");
                }
            });
        },
        {
            threshold: 0.3,
        }
    );

    observer.observe(wrapper);
});



// Turning Uncertainty Into Your Next Opportunity ---on viewport
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector('.bg_overlay_animate');
    const h2 = document.querySelector('.turningmiddletitle h2');
    const originalText = h2.innerHTML; // store original text with <br>

    let wordsTimeout = null;
    let wordsAnimated = false;

    // Function to split words and handle <br> for mobile/desktop
    function splitWords() {
        const isMobile = window.innerWidth <= 575; // mobile breakpoint
        let processedText = isMobile ? originalText.replace(/<br\s*\/?>/gi, ' ') : originalText;

        const parts = processedText.split(/(\s+)/); // split by spaces, keep spaces
        h2.innerHTML = '';

        parts.forEach(part => {
            if (!isMobile && part === '<br>') {
                h2.appendChild(document.createElement('br'));
            } else if (part.trim() !== '') {
                const span = document.createElement('span');
                span.textContent = part;
                h2.appendChild(span);
            } else {
                h2.appendChild(document.createTextNode(part));
            }
        });
    }

    // Word reveal functions
    function animateWords() {
        const spans = h2.querySelectorAll('span');
        spans.forEach((span, i) => {
            setTimeout(() => {
                span.classList.add('active');
            }, i * 180);
        });
    }

    function resetAnimation() {
        const spans = h2.querySelectorAll('span');
        spans.forEach(span => span.classList.remove('active'));
    }

    // Overlay + word animation based on section center
    function checkAnimations() {
        const rect = section.getBoundingClientRect();
        const sectionCenter = rect.top + rect.height / 2;
        const viewportCenter = window.innerHeight / 2;
        const inCenter = Math.abs(sectionCenter - viewportCenter) < rect.height / 2;

        // --- Overlay enter/leave ---
        if (inCenter) {
            section.classList.add('enter');
            section.classList.remove('leave');

            // Start word reveal after overlay animation duration
            if (!wordsAnimated) {
                clearTimeout(wordsTimeout);
                wordsTimeout = setTimeout(() => {
                    animateWords();
                    wordsAnimated = true;
                }, 200); // match overlay transition duration
            }
        } else {
            section.classList.remove('enter');
            section.classList.add('leave');

            clearTimeout(wordsTimeout);
            if (wordsAnimated) {
                resetAnimation();
                wordsAnimated = false;
            }
        }
    }

    // Initial setup
    splitWords();
    checkAnimations();

    // Listen to scroll and resize
    window.addEventListener('scroll', checkAnimations);
    window.addEventListener('resize', () => {
        splitWords(); // re-split on resize for mobile/desktop
        checkAnimations();
    });
});


// Change bg-color on viewport //
const Sections = document.querySelectorAll('.in-reveal');
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // enters viewport
            entry.target.classList.add('active');
        } else {
            // leaves viewport
            entry.target.classList.remove('active');
        }
    });
}, {
    threshold: 0,
    root: null,
    rootMargin: '-50% 0px -100% 0px'
});

Sections.forEach(section => observer.observe(section));






jQuery(document).ready(function ($) {

    var totalFrames = 180;
    var currentFrame = 0;
    var intervalTime = 200;

    // Ensure first image stays visible initially
    $(".bg_video img").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0680/4543/9260/files/Q_LOGO_MOV_00000.webp"
    );

    // Start animation AFTER full page load
    $(window).on("load", function () {

        setInterval(function () {

            var frameNumber = currentFrame.toString().padStart(5, '0');

            var imageUrl =
                "https://cdn.shopify.com/s/files/1/0680/4543/9260/files/Q_LOGO_MOV_" +
                frameNumber +
                ".webp";

            $(".bg_video img").attr("src", imageUrl);

            currentFrame = (currentFrame + 1) % totalFrames;

        }, intervalTime);

    });



    // Highlight the active menu item based on the current page URL//
    var currentPageURL = window.location.href;
    var menuItems = document.querySelectorAll('#primary-menu a.navlink');

    menuItems.forEach(function (item) {
        // Compare href attribute with current page URL
        if (item.href === currentPageURL) {
            // Add active class to the menu item
            item.classList.add('isactive');
        }
    });

    const typed = new Typed("#typed", {
        strings: ["create", "manage", "grow"],
        typeSpeed: 200,
        backDelay: 2000,
        loop: true
    });

});

document.addEventListener("DOMContentLoaded", function () {
    console.clear();
        gsap.registerPlugin(ScrollTrigger);

        const cards = gsap.utils.toArray(".card");

        cards.forEach((card, i) => {
        card.style.zIndex = cards.length - i;
        });
        cards.forEach((card, i) => {
        if (i === cards.length - 1) return; 
            gsap.to(card, {
                scale: 0.92,
                y: -60,
                rotationX: -10,
                opacity: 0.6,
                ease: "none",
                scrollTrigger: {
                trigger: ".cards",
                start: "top 70%", 
                end: "bottom top" ,
                scrub: true,
                invalidateOnRefresh: true,
                }
            });
        });
});



// document.addEventListener("DOMContentLoaded", function () {
//   gsap.registerPlugin(ScrollTrigger);

//   const mm = gsap.matchMedia();
//   const workItems = gsap.utils.toArray(".stack_section.first");

//   mm.add("(min-width: 992px)", () => {
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ".stack_wrapper",
//         start: "top top",
//         end: "bottom bottom",
//         scrub: 0.5,
//         invalidateOnRefresh: true
//       }
//     });

//     workItems.forEach(item => {
//       tl.fromTo(
//         item,
//         { height: "400px", overflow: "hidden" },
//         { height: "6.5rem", duration: 0.5 }
//       );
//     });
//   });

//   mm.add("(max-width: 991px)", () => {
//    const tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".stack_items",  
//     start: "top 80% ",    
//     end: "+=600",            
//     scrub: 0.5,
//     invalidateOnRefresh: true
//   }
// });
//     workItems.forEach(item => {
//       tl.fromTo(
//         item,
//         { height: "200px", overflow: "hidden" },
//         { height: "4.5rem", duration: 0.7 }
//       );
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  if (
    typeof gsap === "undefined" ||
    typeof ScrollTrigger === "undefined"
  ) {
    console.warn("GSAP or ScrollTrigger is not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const mm = gsap.matchMedia();


  /* ==========================================
     DESKTOP ONLY
     992px and above
  ========================================== */

  mm.add("(min-width: 992px)", function () {

    const wrapper = document.querySelector(".stack_wrapper");
    const items = gsap.utils.toArray(".stack_section");

    if (!wrapper || !items.length) return;


    /* Initial setup */
    gsap.set(items, {
      overflow: "hidden"
    });


    /* Scroll animation */
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: "top top",
        end: "bottom bottom",
        scrub: 0.5,
        invalidateOnRefresh: true

        // markers: true
      }
    });


    items.forEach(function (item, index) {

     
      if (index === items.length - 1) {
        return;
      }

      tl.fromTo(
        item,
        {
          height: "400px"
        },
        {
          height: "6.5rem",
          duration: 0.5,
          ease: "none"
        }
      );

    });


    /* Cleanup when moving below 992px */
    return function () {

      if (tl.scrollTrigger) {
        tl.scrollTrigger.kill();
      }

      tl.kill();

      gsap.set(items, {
        clearProps: "height,overflow"
      });

    };

  });


 

  mm.add("(max-width: 991px)", function () {

    const items = gsap.utils.toArray(".stack_section");

    gsap.set(items, {
      clearProps: "height,overflow,transform"
    });


   

    return function () {

      gsap.set(items, {
        clearProps: "height,overflow,transform"
      });

    };

  });


  /* ==========================================
     REFRESH
  ========================================== */

  window.addEventListener("load", function () {
    ScrollTrigger.refresh();
  });

});

document.addEventListener('DOMContentLoaded', function () {
    const engageSwiper = new Swiper('.engageSwiper', {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      speed: 100,
    });
  });


document.addEventListener("DOMContentLoaded", function () {

  $(".tag").draggable({
    containment: ".drag-container",
    stack: ".tag",
    cursor: "grabbing",
    start: function () {
      $(this).css("z-index", 999);
    }
  });

});


gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {

  const cards = gsap.utils.toArray(".stack-card");

  cards.forEach((card, index) => {

    gsap.set(card, {
      zIndex: cards.length - index
    });

    if (index !== cards.length - 1) {
      gsap.to(card, {
        scale: 0.9,
        opacity: 0,
        scrollTrigger: {
          trigger: card,
          start: "top top+=350",
          end: "bottom top",
          scrub: true
        }
      });
    }

  });

  ScrollTrigger.refresh();
});

$(document).ready(function(){
    var swiper = new Swiper(".swiper-container", {
    loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });

});


document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.upload-resume').forEach(function(wrapper){

        const input = wrapper.querySelector('input[type="file"]');
        const fileName = wrapper.querySelector('.file-name');
        const uploadText = wrapper.querySelector('.upload-text');

        input.addEventListener('change', function(){

            if(this.files.length > 0){
                fileName.textContent = this.files[0].name;
                uploadText.style.display = 'none';
            } else {
                fileName.textContent = 'No file selected';
                uploadText.style.display = 'block';
            }

        });

    });

});



const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach((item) => {
    const question = item.querySelector(".faq-question");

    question.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Close all FAQ items
      faqItems.forEach((faqItem) => {
        faqItem.classList.remove("active");
      });

      // Open clicked item if it was closed
      if (!isActive) {
        item.classList.add("active");
      }
    });
  });